const $forms = $('.corp-form');
const cFormsWithHideGeneralError = 'corp-form_hide-general-error';
const $inputs = $forms.find('input, textarea');
const sGroup = '.corp-form__form-group';
const cInputFail = 'corp-form__input_fail';
const cInputError = 'corp-form__input_error';

$inputs.on('eksmoThisInputAjaxFormFail', function (e, errorMessage) {
    const $thisInput = $(this);

    $thisInput.addClass(cInputFail);

    if (typeof errorMessage === 'string') {
        const $group = $thisInput.closest(sGroup);

        if ($group.length) {
            $group.append(`<div class="${cInputError}">${errorMessage}</div>`);
        }
    }

    $thisInput.closest($forms).addClass(cFormsWithHideGeneralError);
});

$inputs.on('eksmoThisInputAjaxFormChange', function () {
    const $thisInput = $(this);
    const $group = $thisInput.closest(sGroup);

    $thisInput.removeClass(cInputFail);

    if ($group.length) {
        $group.find(`.${cInputError}`).remove();
    }

    $thisInput.closest($forms).removeClass(cFormsWithHideGeneralError);
});

$forms.on('eksmoThisAjaxFormSuccess', function () {
    const $thisForm = $(this);
    const h = $thisForm.outerHeight();

    $thisForm.css({ 'min-height': h });
    $thisForm.addClass('corp-form_success');
    $thisForm.html('<div class="corp-form__success"><div class="corp-form__success-icon"></div><div class="corp-form__success-title">Спасибо!</div><div class="corp-form__success-text">Ваша заявка отправлена</div></div>');
});